import {
  createFileRoute, redirect,
} from '@tanstack/react-router';
import { getSettingsByUrlSlug } from '../../api/settings/get-by-url-slug';
import { isNotFoundError, isBadRequestError } from '../../utils/errors';
import SurveyStart from '../../components/pages/survey-start';

export const Route = createFileRoute('/$accountSlug/')({
  validateSearch: (search: Record<string, unknown>) => ({
    m: search.m as string | undefined,
  }),
  loaderDeps: ({ search }) => ({ m: search.m }),
  loader: async ({ params, deps }) => {
    const { accountSlug } = params;
    // this gets the "m" param from the query string on the URL to be sent to the API for validation of the metadata token
    const { m } = deps;
    try {
      const settings = await getSettingsByUrlSlug(accountSlug, m);
      return {
        settings,
        metadataToken: m,
      };
    } catch (err) {
      if (isNotFoundError(err) || isBadRequestError(err)) {
        throw redirect({ href: '/' });
      }
      throw err;
    }
  },
  component: SurveyStart,
});
